export function getBoartStatus(board, status, type) {
    if(type == 'admin') {
        if(board == 1) {
            switch(status) {
                case 1: return 'ปกติ';
                case 2: return 'มีผู้เสนอรับซาก';
                case 3: return 'รอยืนยันนัดรับซาก';
                case 4: return 'ยืนยันนัดรับซาก';
                case 5: return 'ระงับการประกาศ';
                case 6: return 'ซ่อนประกาศ';
                case 9: return 'ทิ้งซากสำเร็จ';
                default: return 'ปกติ';
            }
        } else if(board == 2) {
            switch(status) {
                case 1: return 'ปกติ';
                case 2: return 'มีผู้เสนอรับซาก';
                case 3: return 'รอยืนยันนัดซื้อขายซาก';
                case 4: return 'ยืนยันนัดซื้อขายซาก';
                case 5: return 'ระงับการประกาศ';
                case 6: return 'ซ่อนประกาศ';
                case 9: return 'ซื้อขายซากสำเร็จ';
                default: return 'ปกติ';
            }
        } else if(board == 3) {
            switch(status) {
                case 1: return 'ปกติ';
                case 2: return 'มีผู้เสนอซื้อ';
                case 3: return 'รอยืนยันนัดซื้อขาย';
                case 4: return 'ยืนยันนัดซื้อขาย';
                case 5: return 'ระงับการประกาศ';
                case 6: return 'ซ่อนประกาศ';
                case 9: return 'ซื้อขายสำเร็จ';
                default: return 'ปกติ';
            }
        } else if(board == 4) {
            switch(status) {
                case 1: return 'ปกติ';
                case 2: return 'มีผู้เสนอซื้อ';
                case 3: return 'รอยืนยันการรับซ่อม';
                case 4: return 'ยืนยันนัดซ่อม';
                case 5: return 'ระงับการประกาศ';
                case 6: return 'ซ่อนประกาศ';
                case 9: return 'ซ่อมเสร็จเรียบร้อย';
                default: return 'ปกติ';
            }
        } else if(board == 'air') {
            switch(status) {
                case 1: return 'ปกติ';
                case 2: return 'มีผู้เสนอการล้างแอร์';
                case 3: return 'รอยืนยันการล้างแอร์';
                case 4: return 'ยืนยันนัดล้างแอร์';
                case 5: return 'ระงับการประกาศ';
                case 6: return 'ซ่อนประกาศ';
                case 9: return 'ล้างแอร์เสร็จเรียบร้อย';
                default: return 'ปกติ';
            }
        } else if(board == 'wash') {
            switch(status) {
                case 1: return 'ปกติ';
                case 2: return 'มีผู้เสนอการล้างเครื่องซักผ้า';
                case 3: return 'รอยืนยันการล้างเครื่องซักผ้า';
                case 4: return 'ยืนยันนัดล้างเครื่องซักผ้า';
                case 5: return 'ระงับการประกาศ';
                case 6: return 'ซ่อนประกาศ';
                case 9: return 'ล้างเครื่องซักผ้าเสร็จเรียบร้อย';
                default: return 'ปกติ';
            }
        }
    }
}